import { h } from "preact";
import { useRef, useEffect, useState } from "preact/hooks";
import {
  DistanceIcon,
  PhoneIcon,
  DirectionsIcon,
  VeerChevronIcon,
} from "../../helpers/icons";

export default function FindCertifiedGuideResult({
  result,
  zip,
  countryIsoCode,
}) {
  if (!result) return null;

  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.maxHeight = `${el.scrollHeight}px`;
    requestAnimationFrame(() => setIsVisible(true));
  }, []);

  const imageUrl = result["Guide Image URL"];
  const [title, subtitle] = result.name.split("-").map((str) => str.trim());
  const phone = result["Guide Phone"];
  const directionsUrl = new URL("https://www.google.com/maps/dir/?api=1");
  const distance =
    countryIsoCode === "CA" ? result.distance * 1.60934 : result.distance;
  const distanceUnit = countryIsoCode === "CA" ? "km" : "mi";

  directionsUrl.searchParams.set("origin", zip);
  directionsUrl.searchParams.set("destination", result.address);

  return (
    <li
      ref={ref}
      className={`find-certified-guide__result${isVisible ? " find-certified-guide__result--visible" : ""}`}
    >
      {imageUrl ? (
        <img
          src={window.getSizedImageUrl(imageUrl, "x200")}
          className="find-certified-guide__result-image"
        ></img>
      ) : (
        <div className="find-certified-guide__result-image find-certified-guide__result-image--placeholder">
          <VeerChevronIcon />
        </div>
      )}
      <div className="find-certified-guide__result-title">{title}</div>
      <div className="find-certified-guide__result-subtitle">
        {subtitle ? subtitle : ""}
      </div>
      <div className="find-certified-guide__result-details">
        <div className="find-certified-guide__result-detail">
          <DistanceIcon />
          <span>{`${distance.toFixed(2)} ${distanceUnit}`}</span>
        </div>
        {phone && (
          <div className="find-certified-guide__result-detail">
            <PhoneIcon />
            <a href={`tel:${phone}`}>{phone}</a>
          </div>
        )}
        <div className="find-certified-guide__result-detail">
          <DirectionsIcon />
          <a href={directionsUrl.toString()} target="_blank">
            Directions
          </a>
        </div>
      </div>
    </li>
  );
}
